import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSourceInstitutions,
  fetchTargetInstitution,
  fetchSourceSyllabuses,
  fetchTargetSyllabuses,
  fetchSourceSyllabusActivities,
  fetchSimulateEquivalencyRequest,
  saveStudent,
  saveRequest
} from '../../application/Request/requestSlice';
import {
  fetchRequestFromSearch
} from '../../application/SearchRequest/requestSearchSlice';
import { errorCodes } from '../../shared/utils/errors'

interface ErrorStore {
  error: boolean,
  statusCode: errorCodes | null
}

const initialState:ErrorStore = {
  error: false,
  statusCode: null
};

export const errorHandlerSlice = createSlice({
  name: 'errorHandler',
  initialState,
  reducers: {
    setErrorTrue: (state) => {
      state.error = true;
    },
    setErrorFalse: (state) => {
      state.error = false;
    }
  },
  extraReducers: (builder) => {
    const thunks = [
      fetchSourceInstitutions,
      fetchTargetInstitution,
      fetchSourceSyllabuses,
      fetchTargetSyllabuses,
      fetchSourceSyllabusActivities,
      fetchSimulateEquivalencyRequest,
      saveStudent,
      saveRequest,
      fetchRequestFromSearch
    ];

    thunks.forEach((thunk) => {
      builder.addCase(thunk.rejected, (state, action:any) => {
        if (action.payload?.status) {
          state.error = true;
          state.statusCode = action.payload.status;
        }
      });
    });
  }
});

export const { setErrorTrue, setErrorFalse } = errorHandlerSlice.actions;

export default errorHandlerSlice.reducer;
